/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EventType {
  Unknown = 'Unknown',
  Physical = 'Physical',
  Virtual = 'Virtual'
}
